import React from 'react'
import PropTypes from 'prop-types'
import { Typography, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import Link from 'components/common/Link'
import { get } from 'lodash'
import { getCustomerDetailsPageUrl } from 'router/routes'

const RenderAgingBucketAccountRow = ({ accountData }) => {
  const theme = useTheme()
  const accountNumber = get(accountData, 'accountNumber')
  const accountName = get(accountData, 'accountName')
  const accountId = get(accountData, 'accountId')
  const billingProfileName = get(accountData, 'accountBilling.billingProfile.profile')
  const accountDetailsUrl = getCustomerDetailsPageUrl(accountId)
  return (
    <Grid container sx={{ width: '100%' }} alignItems="center">
      <Grid
        container
        alignItems="center"
        spacing={1}
        sx={{
          px: 2,
          py: 1,
        }}
        size={12}
      >
        <Grid>
          <Link to={accountDetailsUrl} variant="body1" fontWeight={500} sx={{ color: theme.palette.info.light }}>
            {accountNumber}
          </Link>
        </Grid>
        <Grid size="grow">
          <Typography variant="h6" color="textPrimary">
            {accountName}
          </Typography>
        </Grid>
        <Grid>
          <Typography variant="body1" color="textPrimary">
            {billingProfileName}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

RenderAgingBucketAccountRow.propTypes = {
  accountData: PropTypes.object,
}

export default RenderAgingBucketAccountRow
